module.exports = __webpack_public_path__ + "summernote.7e263200d01fb5998c40.eot";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/vendor/summernote/summernote.eot?ad8d7e2d177d2473aecd9b35d16211fb
// module id = ../../../../../src/vendor/summernote/summernote.eot?ad8d7e2d177d2473aecd9b35d16211fb
// module chunks = styles